import type { LocaleData } from '@/types/inertia-shared';
import { useTypedPageProps } from '@/composables/inertia/use-typed-page-props';

/**
 * Get locale data (timezone, city, state, country, currency)
 */
export function useLocale(): LocaleData {
    try {
        const { init } = useTypedPageProps().props;
        return init.locale;
    } catch (error) {
        // Fallback for legacy blade templates (lacks inertia support)
        return global.locale || {
            timezone: '',
            city: '',
            state: '',
            country: 'GB',
            currency: 'GBP',
            currencySign: '£',
            locale: 'en-GB'
        };
    }
}

